import {
  CapitalAccountsNumbersAggregationChart,
  CapitalAccountsSummaryTable,
} from '../../../../components';
import { type CapitalAccountsStoreState } from '../../../../store/slices';
import { CombinedContributionCommitmentChart } from 'components/Charts/CombinedContributionCommitmentChart/CombinedContributionCommitmentChart';
import {
  type FC,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import { type TableColumnDisplayValues } from 'types';

export const CapitalAccountsSummary: FC = () => {
  const {
    capitalAccountsData,
    summaryStatistics,
  } = useSelector<{
    capitalAccounts: CapitalAccountsStoreState,
  }>(
    (state) => state.capitalAccounts,
  ) as CapitalAccountsStoreState;
  const containerRef = useRef<HTMLDivElement>(null);
  const amountOfAccounts = capitalAccountsData?.flatMap((fund) => fund.accounts);

  return (
    <>
      {amountOfAccounts && amountOfAccounts?.length > 1 &&
        <div className='flex h-auto w-full'>
          <CapitalAccountsNumbersAggregationChart values={summaryStatistics as TableColumnDisplayValues} />
        </div>}
      {
        summaryStatistics &&
        <div className='flex flex-col flex-wrap gap-[1rem] overflow-hidden rounded-medium bg-white-999 p-[1rem] shadow-card-x3 dt:flex-row ms:p-[1.25rem]'>
          <CombinedContributionCommitmentChart
            commitmentValues={summaryStatistics}
            contributionValues={summaryStatistics}
          />
        </div>
      }
      <div
        className='rotateX-180 main-white-card flex-col rounded-medium p-0.875 shadow-card-x3'
        ref={containerRef}
      >
        <CapitalAccountsSummaryTable />
      </div>
    </>
  );
};
